import styled from 'styled-components'

export const BowtieAlarmsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    overflow: auto;
    * {
        scrollbar-width: auto;
        scrollbar-color: var(--gray-300) var(--gray-100);
    }

    *::-webkit-scrollbar {
        width: 16px;
    }

    *::-webkit-scrollbar-track {
        background: var(--gray-100);
    }

    *::-webkit-scrollbar-thumb {
        background-color: var(--gray-300);
        border-radius: 10px;
        border: 3px solid var(--gray-100);
    }
`

export const AbsoluteLoadingContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 16px;
    background: var(--gray-300);
`
